/**
 * 固定盐值
 */
const SALT = 'zingai_salt_2025';

/**
 * 对密码进行加盐SHA256加密（使用浏览器原生 Web Crypto API）
 * @param password 明文密码
 * @returns Promise<string> 加密后的十六进制字符串
 */
export async function hashPassword(password: string): Promise<string> {
  // 拼接密码和盐值
  const saltedPassword = password + SALT;
  
  // 使用浏览器原生 Web Crypto API 进行 SHA256 加密
  const encoder = new TextEncoder();
  const data = encoder.encode(saltedPassword);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  
  // 转换为十六进制字符串
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  
  return hashHex;
}
